"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconDefaultProps = exports.default = void 0;

var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles/makeStyles.js"));

var _react = _interopRequireDefault(require("react"));

var _Colors = _interopRequireDefault(require("../../styles/Colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _makeStyles.default)({
  root: function root(_ref) {
    var fill = _ref.fill;
    return {
      fill: fill || _Colors.default.white
    };
  }
});

var SVG = function SVG(_ref2) {
  var path = _ref2.path,
      fill = _ref2.fill,
      style = _ref2.style,
      width = _ref2.width,
      height = _ref2.height,
      viewBox = _ref2.viewBox,
      className = _ref2.className;

  var _useStyles = useStyles({
    fill: fill
  }),
      root = _useStyles.root;

  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: style,
    width: width,
    height: height,
    viewBox: viewBox,
    path: path,
    className: "".concat(root, " ").concat(className)
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: path
  }));
};

SVG.defaultProps = {
  style: undefined,
  fill: _Colors.default.black,
  className: ''
};
var iconDefaultProps = {
  fill: _Colors.default.textElementGrey,
  width: 32,
  height: 32,
  className: '',
  onClick: undefined
};
exports.iconDefaultProps = iconDefaultProps;
var _default = SVG;
exports.default = _default;